import React, { useState } from "react";
import { Menu } from "lucide-react";
import MenuDrawer from "@/components/mobile/MenuDrawer";
import useUnreadNotifications from "@/hooks/useUnreadNotifications";

/**
 * Top-right menu trigger. Opens the full-height right-side navigation drawer.
 * Shows a small red dot when the user has unread notifications.
 */
export default function MenuButton({ testid = "menu-open" }) {
  const [open, setOpen] = useState(false);
  const { count: unread } = useUnreadNotifications();
  return (
    <>
      <button
        data-testid={testid}
        onClick={() => setOpen(true)}
        aria-label="Open menu"
        className="relative grid place-items-center w-11 h-11 rounded-full bg-primary text-primary-foreground shadow-[0_6px_16px_-6px_rgba(198,81,47,0.6)] hover:opacity-90 transition-opacity"
      >
        <Menu className="w-5 h-5" strokeWidth={2.4} />
        {unread > 0 && (
          <span
            data-testid="menu-btn-dot"
            className="absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-[#FFD24A] border-2 border-background"
          />
        )}
      </button>
      <MenuDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
